module.exports = __webpack_public_path__ + "img/WorldCheckLogo.4d74577.png";